"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { useEffect, useState } from "react"
import { FileUploadIcon, NewText } from "ui"
import { sharedColors as colors } from "ui/theme/colors"
import { FileState } from "./FormComponent"

const StyledBox = styled.div`
  display: flex;
  max-width: 600px;
  padding: 24px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  box-shadow: 0px 4px 12px 0px #00000029;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  width: 100%;
  min-height: 260px;
  ${(props) => props.theme.breakpoints.up("md")} {
    border-radius: 16px;
    max-width: 360px;
  }
`

const StyledIconWrapper = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #e5f3ff;
`

const StyledProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 8px;
  align-self: stretch;
`

const StyledProgressLine = styled.div`
  display: flex;
  height: 6px;
  width: 100%;
  align-items: end;
  align-self: stretch;
  border-radius: 20px;
  background: #f7f7f7;
  justify-content: flex-start;
`
const StyledProgress = styled.div<{ percent: number }>`
  display: flex;
  height: 6px;
  width: ${(props) => props.percent}%;
  align-items: center;
  border-radius: 20px;
  background: ${(p) => p.theme.colors.corpBlue};
`
const StyledDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: stretch;
  width: 100%;
`

type Props = {
  filename: string | null
  filesize: number
  setProgress: React.Dispatch<React.SetStateAction<boolean>>
  setFileState: React.Dispatch<React.SetStateAction<FileState>>
}

function getRandomInteger(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

function UploadProgress({ filename, setProgress, filesize, setFileState }: Props) {
  // eslint-disable-next-line no-unused-vars
  const [_, setStatus] = useState<"Running" | "Finished" | null>(null)
  const [percent, setPercent] = useState<number>(0)
  useEffect(() => {
    const interval = setInterval(() => {
      setPercent((prevProgress) => {
        const newProgress = prevProgress + getRandomInteger(1, 10)
        if (newProgress >= 100) {
          clearInterval(interval)
          return 100
        }
        return newProgress
      })
    }, 700)

    return () => clearInterval(interval)
  }, [])
  useEffect(() => {
    if (percent === 100) {
      setFileState({ file: null, fileError: null, fileName: null, fileSize: 0 })
      setStatus("Finished")
      setProgress(false)
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [percent])
  return (
    <StyledBox>
      <Box display={"flex"} flexDirection={"column"} gap={"16px"} alignItems={"center"}>
        <StyledIconWrapper>
          <FileUploadIcon />
        </StyledIconWrapper>

        <NewText
          component={"h3"}
          desktopFontSize={24}
          desktopLineHeight={"35px"}
          color={colors.black}
          textAlign={"center"}
        >
          מעלים את קורות החיים שלך
        </NewText>
      </Box>
      <StyledProgressContainer>
        <NewText
          component={"span"}
          desktopFontSize={18}
          desktopLineHeight={"26px"}
          color={colors.black}
        >
          {filename}
        </NewText>
        <StyledProgressLine>
          <StyledProgress percent={percent}>&#8203;</StyledProgress>
        </StyledProgressLine>
        <StyledDetails>
          <NewText
            component={"span"}
            desktopFontSize={18}
            desktopLineHeight={"26px"}
            color={colors.black}
          >
            {percent}%
          </NewText>
          <NewText
            component={"span"}
            desktopFontSize={18}
            desktopLineHeight={"26px"}
            color={colors.black}
          >
            {(filesize / (1024 * 1024)).toFixed(2)}MB
          </NewText>
        </StyledDetails>
      </StyledProgressContainer>
    </StyledBox>
  )
}

export default UploadProgress
